export default "__VITE_ASSET__ql1neUu2__"